import DynamicPropertyFields from "./DynamicPropertyFields.vue";

export { DynamicPropertyFields };
export default DynamicPropertyFields;
